/** True when this exit leaves no open issues, including ones hidden by filters. */
export const getIsLastOpenIssue = ({
  feedbacks,
  dismissedIds,
  totalFeedbacks,
  listedCount,
}: {
  feedbacks: Array<{ id: string }>;
  dismissedIds: ReadonlySet<string>;
  totalFeedbacks: number;
  /**
   * Length of the list before visibility / merge filtering.
   * Filter-hidden issues are `totalFeedbacks > listedCount`.
   * Defaults to `feedbacks.length` when the two lists are the same.
   */
  listedCount?: number;
}) => {
  const remainingOpen = feedbacks.filter((feedback) => !dismissedIds.has(feedback.id)).length;
  const hasHiddenIssues = totalFeedbacks > (listedCount ?? feedbacks.length);
  return remainingOpen === 0 && !hasHiddenIssues;
};
